const IMAGE_TYPE = "wix-draft-plugin-image";
export {
  IMAGE_TYPE
};
//# sourceMappingURL=types.js.map
